import { render, staticRenderFns } from "./GasIcon.vue?vue&type=template&id=3ec8576e&"
import script from "./GasIcon.vue?vue&type=script&lang=js&"
export * from "./GasIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports